import API from '@/lib/API.js'
import comun from './comun.js'
const sectores = {
    namespaced: true,
    state: {
        Lista: [],
        Filtradas: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Filtradas = [];
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.getSectores();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Sectores.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let sec = state.Lista.find((x) => x.id_sector == payload)
            commit("select", sec)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let sec = {
                id_sector: 0,
                Descripcion_sector: ""
            }
            commit("select", sec)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_sector != 0) {
                data = await API.Sectores.modificar(state.Seleccionado);
                str += "Sector modificado"
            } else {
                data = await API.Sectores.alta(state.Seleccionado);
                str += `Nuevo sector de alta'${data.Descripcion_sector}'`
            }
            let secs = await API.Sectores.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.id_sector)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            let data = []
            let str = ""
            if (entidad.id_sector != 0) {
                data = await API.Sectores.modificar(entidad);
                str += "Sector modificado"
            } else {
                data = await API.Sectores.alta(entidad);
                str += `Nuevo sector de alta'${data.Descripcion_sector}'`
            }
            let secs = await API.Sectores.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.id_sector)
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Sectores.eliminar(id);
                str += "Sector eliminada"
            }
            let ents = await API.Sectores.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    getters: {
        getSectores: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }
}
export default sectores;